const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'low-anxiety',
        conditions: [{ id: 'score', min: 14, max: 28, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    },
    {
        id: 'moderate-anxiety',
        conditions: [{ id: 'score', min: 29, max: 42, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    },
    {
        id: 'high-anxiety',
        conditions: [{ id: 'score', min: 43, max: 56, value: e => findByAddress(e, 'evalEmotional.answerScore') }],
    }
]);